import React from "react";
import { useTranslation } from "react-i18next";

import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import AlertsSection from "./sections/AlertsSection";
import DashboardMainSection from './sections/DashboardMainSection';
import MarketingConsentsSection from "features/consents/sections/MarketingConsentsSection";
import { loadPortalConfig } from "features/shared/helpers/modules";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { useSelector } from "react-redux";
import IAppState from "infrastructure/store/IAppState";
import { UserState } from "redux-oidc";
import RolesChecker from "features/customer/components/RolesChecker";
import MarketingConsentsState from "infrastructure/store/marketingConsents/MarketingConsentsState";
import { isAdminUser } from "infrastructure/oidc/oidcHelper";

const portalConfig = loadPortalConfig();

interface IProps {}

const Dashboard: React.FC<IProps> = (props) => {
  // translations
  const { t } = useTranslation("shared\\moduleNames");
  
  // store
  const user = useSelector<IAppState, UserState>((store) => store.oidc).user;
  const marketingConsentsState = useSelector<IAppState, MarketingConsentsState>((store) => store.marketingConsents);

  // helpers
  const renderMarketingConsents = (): boolean => { 
    // admin user - not show
    if (isAdminUser(user)) {
      return false;
    }
    // user close dialog (didn't answer) - not show
    if (marketingConsentsState.isClosedDialog) {
      return false;
    }

    return true;
  }

  // render
  return (
    <>
      <AlertsSection />
      <Header title={t("dashboard.title")} subtitle={t("dashboard.subtitle")} />
      <ModuleContent>
        <DashboardMainSection />
      </ModuleContent>
      <RenderWrapper isVisible={() => portalConfig.enableMarketingConsents}>
        <RenderWrapper isVisible={renderMarketingConsents}>
          <RolesChecker enabledRoles="Contributor" >
            <MarketingConsentsSection />
          </RolesChecker>
        </RenderWrapper>
      </RenderWrapper>
    </>
  );
};

export default Dashboard;